export enum eventType {
	ondemand = 'ONDEMAND',
	normal = 'NORMAL',
	online = 'ONLINE',
}
